import { render, staticRenderFns } from "./TotalTweets.vue?vue&type=template&id=5fc15a70&"
import script from "./TotalTweets.vue?vue&type=script&lang=js&"
export * from "./TotalTweets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports